import { BlogIndexPage } from 'components/blog/blog-index-page';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchTaggedArticles } from 'queries';

const PerspectivesRoute = ({ ssr, router, session, store, toast }) => {
	// Render
	return <BlogIndexPage title='Perspectives' ssr={ssr} />;
};

PerspectivesRoute.getLayout = (page, ssr) => {
	const tag = ssr.tag?.data || {};
	return <BlogWrapper seo={{ description: tag.description }}>{page}</BlogWrapper>;
};

export async function getServerSideProps({ params, query }) {
	const articles = await fetchTaggedArticles('perspectives', { params, query });
	return { props: { articles } };
}

export default PerspectivesRoute;
